export const MOST_POPULAR_CERT_PROD = [29, 1028124, 15, 117, 24, 25, 11, 12, 9, 5, 116, 66];
export const MOST_POPULAR_CERT_IDS_QA = [407009, 162428, 162778, 397673, 272481, 162869, 270706];
export const getPopularEnglishCerts = () => {
  if (window.enviro.isQa()) {
    return MOST_POPULAR_CERT_IDS_QA;
  } else {
    return MOST_POPULAR_CERT_PROD;
  }
};
export const RECOMMENDED_FOR = {
  24: ['inboundProfessionals', 'marketingProfessionals', 'salesProfessionals'],
  29: ['socialMediaMarketers', 'marketingProfessionals', 'aspiringMarketers'],
  1028124: ['inboundProfessionals', 'marketingProfessionals'],
  15: ['marketingProfessionals', 'inboundProfessionals', 'contentProducers'],
  117: ['marketingProfessionals', 'contentMarketers', 'aspiringMarketers'],
  11: ['marketingProfessionals'],
  25: ['marketingProfessionals', 'contentProducers'],
  9: ['salesProfessionals', 'salesManagers'],
  5: ['marketingProfessionals'],
  12: ['salesProfessionals', 'salesManagers'],
  116: ['marketingProfessionals', 'advertisingProfessionals'],
  36: ['salesManagers'],
  66: ['salesManagers', 'salesLeaders'],
  19: ['marketingManagers', 'salesManagers'],
  97: ['customerServiceManagers, customerServiceAgents'],
  87: ['marketingProfessionals, webDevelopers']
};